import type { RouteDataFunc } from "@solidjs/router";
import { verifyEmail } from "supertokens-web-js/recipe/emailverification";
import EventAnalytics from "~/js/utilities/EventAnalytics";
import { getPrivateMessageFromError } from "~/solidJs/shared/helpers/errorHelpers";
import { verifyUser } from "~/solidJs/shared/helpers/userHelpers";
export const verifyEmailDataFc: RouteDataFunc = async (props) => {
	EventAnalytics.verifyEmailEvent();
	verifyEmail()
		.then((val) => {
			if (val.status === "OK") {
				verifyUser();
			} else {
				EventAnalytics.sendErrorInfo("ss_email_verification_error", {
					message: val?.status
				});
			}
		})
		.catch((err) => {
			EventAnalytics.sendErrorInfo("ss_email_verification_error", {
				message: getPrivateMessageFromError(err)
			});
		})
		.finally(() => props.navigate("/", { replace: true }));
};
